import { render, staticRenderFns } from "./ImageGallery.vue?vue&type=template&id=16eddb05&scoped=true"
import script from "./ImageGallery.vue?vue&type=script&lang=ts"
export * from "./ImageGallery.vue?vue&type=script&lang=ts"
import style0 from "./ImageGallery.vue?vue&type=style&index=0&id=16eddb05&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16eddb05",
  null
  
)

export default component.exports